import React from "react";
import "./hero.scss";

function Hero() {
  return (
    <div className="hero">
      <div className="inner-hero">
        <div>
          <h1>Welcome to Ecom</h1>
          <p> - Buy yourself something pretty</p>
        </div>
      </div>
    </div>
  );
}

export default Hero;
